const toolTipData = [
  {
    id: "fromDate",
    text: "Select From date."
  },
  {
    id: "toDate",
    text: "Select To date."
  },
  {
    id: "locationName",
    text: "Select Location to Get the Users Attendance."
  },
  {
    id: "Filter",
    text: "Search by User-id, Aadhar-Card, Full Nam."
  }
];

const tableHeaderData = [
  {
    label: "User Id",
    place: "top",
    type: "workerId",
    toolTipText: "Click for E-ID Sorting"
  },
  {
    label: "Full Name",
    place: "top",
    type: "workerFullName",
    toolTipText: "Click for Full Name Sorting"
  }
  // {
  //   label: "Department",
  //   place: "left",
  //   type: "workerDepartment",
  //   toolTipText: "Click for Department Sorting"
  // },
  // {
  //   label: "Designation",
  //   place: "left",
  //   type: "workerDesignation",
  //   toolTipText: "Click for Designation Sorting"
  // },
  // {
  //   label: "Location",
  //   place: "left",
  //   type: "Location",
  //   toolTipText: "Click for Location Sorting"
  // }
];

export { toolTipData, tableHeaderData };
